<div class="scroll-to-top" [ngClass]="{'show-scrollTop': isScrolled}" (click)="scrollToTop()">
    <mat-icon>arrow_upward</mat-icon>
</div>
